import '@caresend/types';
import '@caresend/utils';
import 'firebase/auth';
import '../database/firebaseConfig/cloudFunctions.js';
import '../database/firebaseConfig/init.js';
import '../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../components/ui/Icon.vue.js';
import './configuration/icons.js';
import '../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import './tracking/index.js';
import '../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { removeSpaces } from './misc.js';

const openMapDirection = (location) => {
    const url = `https://www.google.com/maps/dir/?api=1&origin=my+location&destination=${location.lat},${location.lng}`;
    window.open(url, '_blank');
};
const getLocation = (addressComponents) => {
    const location = { country: '', state: '', city: '' };
    addressComponents.forEach((locationEntry) => {
        const locationType = locationEntry.types[0];
        if (locationType === 'locality') {
            location.city = removeSpaces(locationEntry.long_name);
        }
        else if (locationType === 'administrative_area_level_1') {
            location.state = removeSpaces(locationEntry.short_name);
        }
        else if (locationType === 'country') {
            location.country = removeSpaces(locationEntry.short_name);
        }
    });
    return location;
};

export { getLocation, openMapDirection };
